import { FC } from 'react';
import IconArrowCut from 'assets/icons/arrow-cut.svg?react';
import IconArrowFull from 'assets/icons/arrow.svg?react';
import { cn } from 'utils/helpers';

export type ForwardArrowProps = {
  arrowType?: 'full' | 'cut';
  className?: string;
};

export const ForwardArrow: FC<ForwardArrowProps> = ({
  arrowType = 'cut',
  className = '',
}) => {
  const newClassName = cn('h-12 w-7', className);

  return arrowType === 'cut' ? (
    <IconArrowCut className={newClassName} />
  ) : (
    <IconArrowFull className={newClassName} />
  );
};
